module.exports = __webpack_public_path__ + "img/connector.0718b5ad.svg";